export enum FormsDataActionType {
  SET_PERSONAL_DATA = 'formsData/SET_PERSONAL_DATA',
  SET_CONTACT_INFORMATION = 'formsData/SET_CONTACT_INFORMATION',
  SET_COMPANY_DATA = 'formsData/SET_COMPANY_DATA',
  SET_EMPLOYMENT_INFORMATION = 'formsData/SET_EMPLOYMENT_INFORMATION',
  SET_ASSETS = 'formsData/SET_ASSETS',
  SET_LIABILITIES = 'formsData/SET_LIABILITIES',
  SET_INITIAL_CONSENTS = 'formsData/SET_INITIAL_CONSENTS',
  UPDATE_DATA_PRIVACY_STATEMENT = 'formsData/SET_DATA_PRIVACY_STATEMENT',
  SET_CO_APPLICANT_DATA = 'formsData/SET_CO_APPLICANT_DATA',
  PERFORM_AML_CHECK = 'formsData/PERFORM_AML_CHECK',
  CHECK_AML_STATUS = 'formsData/CHECK_AML_STATUS',
  SET_REFERENCE_CONTACTS = 'formsData/SET_REFERENCE_CONTACTS',
  REMOVE_COAPPLICANT = 'formsData/REMOVE_COAPPLICANT',
}